import axios, { AxiosResponse } from 'axios'
import {
  AvaliacoesQueryResponse,
  FormularioAtendimentoDto,
  FormularioAtendimentoDtoAdd,
  FormularioAtendimentoView,
} from './_models'
import { ID } from '../../../../../../_metronic/helpers'
import { ArquivoDto, AtendimentoDto } from '../../../atendimento/core/_models'
import {
  FormularioEnvioDto,
  FormularioResolvido,
} from '../../../formularios/formularios-create/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const AVALIACOES_URL = `${API_URL}/atendimentos/formulario`

/**
 * Busca formulários de atendimento
 * @param query string
 * @returns AvaliacoesQueryResponse
 */
export const getAvaliacoes = (query: string): Promise<AvaliacoesQueryResponse> => {
  return axios
    .get(`${AVALIACOES_URL}?${query}`)
    .then((d: AxiosResponse<AvaliacoesQueryResponse>) => d.data)
}

export const downloadAvaliacaoLote = (avaliacoesIds: ID[]): Promise<ArquivoDto[]> => {
  const query = avaliacoesIds.join(',')
  return axios
    .get(`${AVALIACOES_URL}/download?formularios=${query}`)
    .then((resp: AxiosResponse<ArquivoDto[]>) => resp.data)
}

/**
 * Download de formulário de atendimento
 * @param idAtendimento Identificador do atendimento
 * @param formularioAtendimentoId Identificador do formularioAtendimento
 * @returns ArquivoDto
 */
export const downloadAvaliacao = (
  idAtendimento: ID,
  formularioAtendimentoId: ID
): Promise<ArquivoDto> => {
  return axios
    .get(`${AVALIACOES_URL}/download/${idAtendimento}/${formularioAtendimentoId}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Busca od formulários de atendimento do profissional autenticado
 * @param query string
 * @returns AvaliacoesQueryResponse
 */
export const getAvaliacoesByResponsavel = (query: string): Promise<AvaliacoesQueryResponse> => {
  return axios
    .get(`${AVALIACOES_URL}/responsavel?${query}`)
    .then((d: AxiosResponse<AvaliacoesQueryResponse>) => d.data)
}

/**
 * Detalhes de formulário de atendimento
 * @param atendimentoId ID do atendimento
 * @param idFormularioAtendimento ID do formulario atendimento
 * @returns FormularioAtendimentoView
 */
export const getFormularioAtendimento = (
  atendimentoId: ID,
  idFormularioAtendimento: ID
): Promise<FormularioAtendimentoView> => {
  return axios
    .get(`${AVALIACOES_URL}/${atendimentoId}/${idFormularioAtendimento}`)
    .then((resp: AxiosResponse<FormularioAtendimentoView>) => resp.data)
}

/**
 * Busca o formulário de um atendimento pronto para preenchimento: campos com código estável,
 * condição de exibição e as variáveis do atendimento referenciadas por essas condições.
 * @param atendimentoId ID do atendimento
 * @param idFormularioAtendimento ID do formulário do atendimento
 * @returns FormularioResolvido
 */
export const getFormularioResolvido = (
  atendimentoId: ID,
  idFormularioAtendimento: ID
): Promise<FormularioResolvido> => {
  return axios
    .get(`${AVALIACOES_URL}/${atendimentoId}/${idFormularioAtendimento}/resolvido`)
    .then((resp: AxiosResponse<FormularioResolvido>) => resp.data)
}

/**
 * Envia as respostas de um formulário de atendimento, identificadas pelo código do campo.
 * O backend revalida as condições e os obrigatórios visíveis antes de gravar.
 * @param atendimentoId ID do atendimento
 * @param idFormularioAtendimento ID do formulário do atendimento
 * @param envio FormularioEnvioDto
 */
export const enviarFormulario = (
  atendimentoId: ID,
  idFormularioAtendimento: ID,
  envio: FormularioEnvioDto
): Promise<AtendimentoDto> => {
  return axios
    .post(`${AVALIACOES_URL}/${atendimentoId}/${idFormularioAtendimento}/enviar`, envio)
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Altera respostas de um formulario de atendimento
 * @param answersForm FormularioAtendimentoDto
 * @param atendimentoId ID do atendimento
 * @returns void
 */
export const updateAnswersFormulario = (
  answersForm: FormularioAtendimentoDto,
  atendimentoId: ID
): Promise<void> => {
  return axios.patch(`${AVALIACOES_URL}/${atendimentoId}`, answersForm)
}

/**
 * Adiciona formulárioo em um atendimento
 * @param atendimentoId ID do atendimento
 * @param data FormularioAtendimentoDtoAdd
 * @returns AtendimentoDto
 */
export const addFormularioToAtendimento = (
  atendimentoId: number,
  data: FormularioAtendimentoDtoAdd
): Promise<AtendimentoDto> => {
  return axios
    .put(`${AVALIACOES_URL}/${atendimentoId}`, data)
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Remove formulario de um atendimento
 * @param atendimentoId ID do atendimento
 * @param idFormularioAtendimento ID do formulario atendimento
 * @returns AtendimentoDto
 */
export const deleteFormularioAtendimento = (
  atendimentoId: number,
  idFormularioAtendimento: number
): Promise<AtendimentoDto> => {
  return axios
    .delete(`${AVALIACOES_URL}/${atendimentoId}`, { params: { idFormularioAtendimento } })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}
